import classnames from 'classnames';
import React, { useEffect, useRef } from 'react';
import styles from '../styles.module.css';

const Input = ({
    props: { id, inline, style, type, name },
    inputRef,
    handleBlur,
    handleKeydown,
    handleFocus,
    inputClassName,
    ...rest
}) => {
    const textareaRef = useRef(null);

    // Function to auto-resize textarea
    const autoResize = (textarea) => {
        if (textarea) {
            // Reset height to auto to get the correct scrollHeight
            textarea.style.height = 'auto';
            // Set height to scrollHeight to fit content
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    // Auto-resize textarea based on content when component mounts or value changes
    useEffect(() => {
        if (type === 'textarea' && textareaRef.current) {
            autoResize(textareaRef.current);
        }
    }, [type, rest.value, rest.defaultValue]);

    // Handle input changes for dynamic resizing
    const handleInput = (e) => {
        autoResize(e.target);
        // Call the original onChange if it exists
        if (rest.onChange) {
            rest.onChange(e);
        }
    };

    // Use textarea for multiline input when type is 'textarea'
    if (type === 'textarea') {
        return (
            <textarea
                id={id}
                className={classnames(styles.shared, inputClassName, {
                    [styles.inline]: inline
                })}
                style={{
                    ...style,
                    resize: 'vertical',
                    minHeight: '60px',
                    lineHeight: '1.4',
                    overflow: 'hidden' // Prevent scrollbar during auto-resize
                }}
                ref={(ref) => {
                    textareaRef.current = ref;
                    if (inputRef) {
                        if (typeof inputRef === 'function') {
                            inputRef(ref);
                        } else {
                            inputRef.current = ref;
                        }
                    }
                }}
                name={name}
                onBlur={handleBlur}
                onKeyDown={handleKeydown}
                onInput={handleInput}
                autoFocus
                onFocus={handleFocus}
                {...rest}
            />
        );
    }

    // Default input for single-line text
    return (
        <input
            id={id}
            className={classnames(styles.shared, inputClassName, {
                [styles.inline]: inline
            })}
            style={style}
            ref={inputRef}
            type={type}
            name={name}
            onBlur={handleBlur}
            onKeyDown={handleKeydown}
            autoFocus
            onFocus={handleFocus}
            {...rest}
        />
    );
};

export default Input;
